/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_DescriptionInputs */

const en_wb_operations_description = /** @type {(inputs: Wb_Operations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The required address is missing. Route this to the order owner before it proceeds.`)
};

const lv_wb_operations_description = /** @type {(inputs: Wb_Operations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trūkst obligātās adreses. Novirziet to pasūtījuma atbildīgajam, pirms tas virzās tālāk.`)
};

/**
* | output |
* | --- |
* | "The required address is missing. Route this to the order owner before it proceeds." |
*
* @param {Wb_Operations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_description = /** @type {((inputs?: Wb_Operations_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_description(inputs)
	return en_wb_operations_description(inputs)
});